import styled, { css } from 'styled-components';

import { Column, Flexbox, ROW_BREAKPOINT } from '@seuk/design-system/atoms';

export const CategoryBadge = styled.span`
  ${({ theme }) => css`
    ${theme.typography.label.medium.bold};
    background-color: ${theme.palette.accent.primary.strong};
    padding: ${theme.spacing(3)} ${theme.spacing(5)};
    border-radius: ${theme.radius};
  `}
`;

export const Categories = styled(Flexbox)`
  ${({ theme }) => css`
    gap: ${theme.spacing(3)};
  `}
`;

export const TextColumn = styled(Column)`
  ${({ theme }) => css`
    padding: ${theme.spacing(8)};

    ${theme.breakpoints.up(ROW_BREAKPOINT)} {
      margin-bottom: 0;
      flex: 1;
    }
  `}
`;

export const ArticleHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-evenly;
`;

export const ArticleTitle = styled.h1`
  ${({ theme }) => css`
    ${theme.typography.heading[1].demi};
    color: ${theme.palette.focus.strong};

    ${theme.breakpoints.up(ROW_BREAKPOINT)} {
      margin-bottom: ${theme.spacing(8)};
    }
  `}
`;

export const ArticleSubtitle = styled.h4`
  ${({ theme }) => css`
    ${theme.typography.paragraph.medium.normal};
    ${theme.breakpoints.up(ROW_BREAKPOINT)} {
      margin-bottom: ${theme.spacing(8)};
    }
  `}
`;

export const ContactUsContainer = styled.div`
  ${({ theme }) => css`
    --spacing: ${theme.spacing(3 * 4)};
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-evenly;
    padding: var(--spacing);
  `}
`;
